// extracted by mini-css-extract-plugin
export default {"transaction_expense_wrapper":"TransactionAndExpenseSection_transaction_expense_wrapper__yUWRd"};